{
  "version": 1,
  "asset_id": "6c5145ec-37b5-4fa8-9dd9-e714a4788899",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/6c5145ec-37b5-4fa8-9dd9-e714a4788899/ambree.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/6c5145ec-37b5-4fa8-9dd9-e714a4788899/ambree.webp",
  "original_filename": "ambree.webp",
  "size": 70578,
  "content_type": "image/webp",
  "created_at": "2026-07-21T20:12:29Z"
}
